/**
 * SkipLink — link "Pular para conteudo" para usuários de teclado/screen reader.
 *
 * Por padrao escondido visualmente; quando recebe focus (Tab) aparece
 * no canto superior esquerdo.
 *
 * WCAG 2.1 SC 2.4.1 (Bypass Blocks) — recomendado.
 */
import { useTranslation } from 'react-i18next';

export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="bg-primary text-primary-foreground sr-only fixed left-2 top-2 z-50 rounded px-3 py-2 text-sm font-medium focus:not-sr-only focus:ring-2 focus:ring-offset-2"
    >
      {t('a11y.skip_to_content', 'Pular para conteudo')}
    </a>
  );
}
